import { Typography } from "@mui/material";
import React from "react";
import AllExamAndExercises from "../../components/allExamAndExercises";

const initialHeadCells = [
  {
    id: "title",
    numeric: false,
    label: "الاسم",
  },
  {
    id: "academicYear",
    numeric: false,
    label: "المرحلة الدراسية",
  },
  {
    id: "startDate",
    numeric: false,
    label: "تاريخ البدء",
  },
  {
    id: "endDate",
    numeric: false,
    label: "تاريخ الانتهاء",
  },
  {
    id: "price",
    numeric: true,
    label: "السعر",
  },
];

function ExamsWithSolutions() {
  return (
    <div>
      <>
        <Typography
          style={{ fontSize: "30px", color: "#010004", textAlign: "center" }}
        >
          الامتحانات بالاجابات
        </Typography>
        <AllExamAndExercises
          withEdit={false}
          withDelete={false}
          api={"/exercises/admin/getManyExam/"}
          initialHeadCells={initialHeadCells}
          path={"/exams-solutions/"}
        />
      </>
    </div>
  );
}

export default ExamsWithSolutions;
